import { createTheme, responsiveFontSizes, ThemeProvider } from "@material-ui/core";
import React from "react";
import { Route } from "react-router";
import { Redirect, Switch } from "react-router-dom";
import { Layout } from "./components/Layout/Layout";
import SessionExpiredPopup from "./components/Popups/SessionExpiredPopup";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import TherapistDetails from "./views/TherapistDetails";
import ForgotPassword from "./views/ForgotPassword";
import Home from "./views/Home";
import Login from "./views/Login";
import NotFound from "./views/NotFound";
import PatientProfile from "./views/PatientProfile";
import Patients from "./views/Patients";
import Profile from "./views/Profile";
import Register from "./views/Register";
import Session from "./views/Session";
import Therapists from "./views/Therapists";
import UpdatePassword from "./views/UpdatePassword";

const tema = responsiveFontSizes(createTheme({
    props: {
        MuiButton: {
            disableElevation: true,
            disableRipple: true,
            size: "small",
        },
        MuiCheckbox: {
            disableRipple: true
        },
        MuiTextField: {
            variant: "outlined",
        }
    },
    typography: {
        fontFamily: [
            '"Open Sans"',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    palette: {
        common: {
            "black": "#000",
            "white": "#fff"
        },
        primary: {
            "light": "#00c8ab",
            "main": "#00858B",//"#474B6A",
            "dark": "#006166",
            "contrastText": "#fff"
        },
        secondary: {
            "light": "#F88C91",
            "main": "#F5626A",
            "dark": "#F33F48",
            "contrastText": "#fff"
        },
        error: {
            "light": "#e57373",
            "main": "#f44336",
            "dark": "#d32f2f",
            "contrastText": "#fff"
        },
        text: {
            "primary": "rgba(0, 0, 0, 0.87)",
            "secondary": "rgba(0, 0, 0, 0.54)",
            "disabled": "rgba(0, 0, 0, 0.38)",
            "hint": "rgba(0, 0, 0, 0.38)"
        }
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: ".5rem",
            },
        }
    }
}));


const App = () => {
    return (
        <ThemeProvider theme={tema}>
            <Switch>
                <Route path="/login" exact component={Login} />
                <Route path="/register" component={Register} />
                <Route path="/forgot-password" component={ForgotPassword} />
                <Route path="/update-password" component={UpdatePassword} />
                <Route path="/not-found" component={NotFound} />
                <Layout>
                    <Switch>
                        <PrivateRoute path="/" exact component={Home} />
                        <PrivateRoute path="/profile" exact component={Profile} />
                        <PrivateRoute path="/therapists/:id" exact component={TherapistDetails} />
                        <PrivateRoute path="/therapists" exact component={Therapists} />
                        <PrivateRoute path="/session" exact component={Session} />
                        <PrivateRoute path="/patients" exact component={Patients} />
                        <PrivateRoute path="/patients/:id" exact component={PatientProfile} />
                        <Redirect to="/not-found" />
                    </Switch>
                </Layout>
                <Redirect to="/not-found" />
            </Switch>
            <SessionExpiredPopup />
        </ThemeProvider>
    );
};
export default App;
